<template>
  <div class="scribbles" :style="{position: fixed ? 'fixed': 'absolute'}">
    <AnimatedScribble v-for="i in num" :key="i" :red-stroke="i - 1 === redStrokeIndex" :x="0.5 + 0.5 * Math.cos(2 * Math.PI * i / num)" :y="0.5 + 0.5 * Math.sin(2 * Math.PI * i / num)" />
  </div>
</template>

<script>
import AnimatedScribble from '@/atoms/AnimatedScribble'

export default {
  name: 'Scribbles',
  components: {
    AnimatedScribble
  },
  data () {
    return {
      redStrokeIndex: 0
    }
  },
  created () {
    this.redStrokeIndex = Math.floor(Math.random() * this.num)
  },
  props: {
    num: {
      type: Number,
      required: false,
      default: 4
    },
    fixed: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.scribbles {
  // position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>
